import React from "react";
import styled from "styled-components";

// checkbox
const CheckboxWrap = ({ children, ...props }) => {
    let { gap, col, row, name, stateValue, onChange } = props;

    return (
        <CustomCheckboxWrap gap={gap} col={col} row={row}>
            {React.Children.map(children, (child, idx) => React.cloneElement(child, { name, idx, stateValue, onChange }))}
        </CustomCheckboxWrap>
    );
};

const CustomCheckboxWrap = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 5px;

    ${(props) => props.gap && `gap: ${props.gap}px;`};
    ${(props) => props.col && `flex-direction: column;`};
    ${(props) => props.row && `flex-direction: row;`};
`;

let CustomCheckbox = styled.label`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    cursor: pointer;

    span {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        background-color: #fff;
        border: 1px solid var(--gray-color);
        aspect-ratio: 1/1;

        &:before {
            content: "";
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 12px;
            height: 12px;
            background-color: #fff;
            aspect-ratio: 1/1;
        }
    }

    &:has(input:checked) span {
        &:before {
            background-color: var(--gray-color);
        }
    }

    input {
        display: none;
    }
`;

const Checkbox = ({ children, ...props }) => {
    let { disabled, name, id, value, idx, stateValue, onChange } = props;

    id = id ? id : idx >= 0 ? `${name}_${idx}` : "";

    const onChangeHandler = (e) => {
        if (onChange) {
            onChange();
        } else {
            stateValue[1]({ ...stateValue[0], [value]: !stateValue[0][value] });
        }
    };

    return (
        <>
            <CustomCheckbox htmlFor={id}>
                <span></span>
                <input type="checkbox" name={name} id={id} disabled={disabled} checked={stateValue[0][value] ? true : false} onChange={(e) => onChangeHandler(e)} />
                {children} / {name} / {id} / {idx} / {value}
            </CustomCheckbox>
        </>
    );
};

export { CheckboxWrap, Checkbox };
